<div class="ratSelect" [formGroup]="form">
  <select class="form-select" [id]="question?.quesId+'_id_'+controlIndex"
    [formControlName]="question?.quesId+'_id_'+controlIndex"
    (change)="inputChange($event, question?.quesId+'_id_'+controlIndex)" required [attr.disabled]="isDisabled"
    [ngClass]="isArabic ? 'rightAlign' : ''">
    <!-- <option value="-1" *ngIf="assessmentType === 'generalAssessment'">{{question?.label}}</option> -->
    <option value="-1" *ngIf="assessmentType === 'mainAssessment'">
      <span *ngIf="!isArabic">Select Option</span>
      <span *ngIf="isArabic">اختر خياراً</span>
      <!-- <span *ngIf="!isArabic"></span>
        <span *ngIf="isArabic"></span> -->
    </option>
    <option *ngFor="let opt of eachControl?.options; let idx = index;" [value]="opt?.value">
      <span *ngIf="!isArabic">{{opt?.value}}</span>
      <span *ngIf="isArabic">{{opt?.valueArabic}}</span>
    </option>
  </select>
</div>
<ng-container class="error-container">
  <app-rat-errormsg [question]="question" [eachControl]="eachControl" [controlIndex]="controlIndex"
    [form]="form"></app-rat-errormsg>
</ng-container>